import ModalContent from './ModalContent'
export type * from './ModalContent'
export default ModalContent
